import { render, staticRenderFns } from "./ScanPackages.vue?vue&type=template&id=623b05b8&scoped=true"
import script from "./ScanPackages.vue?vue&type=script&lang=js"
export * from "./ScanPackages.vue?vue&type=script&lang=js"
import style0 from "./ScanPackages.vue?vue&type=style&index=0&id=623b05b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b05b8",
  null
  
)

export default component.exports